import initMap from './init-map';
import throttle from '../common/throttle';
import globalFunctions from "../common/global-functions"; 

const progressBar = require('nprogress');

let filters = {};
let subcategories = [];
let neighborhoods = [];
let addinfos = [];
let startDate = null;
let endDate = null;
if ($('#js-get-json-filter').val()){
    filters = JSON.parse($('#js-get-json-filter').val());
    subcategories = filters.subcategories;
    filters.subcategories = subcategories.join(',');
    neighborhoods = filters.neighborhoods;
    filters.neighborhoods = neighborhoods.join(',');
    addinfos = filters.addinfos;
    filters.addinfos = addinfos.join(',');
    startDate = filters.startDate;
    filters.startDate = startDate;
    endDate = filters.endDate;
    filters.endDate = endDate;
}

let multipleFilters = ['neighborhood', 'addinfo'];

$.each(multipleFilters, (key, parentItem) => {
    $.each($('.js-'+parentItem+'-child'), (key, item) => {
    let parentName = $(item).data(parentItem+'-parent');
    if (item.checked) {
        let parent = $('.js-'+parentItem+'-parent[data-'+parentItem+'-parent-name="' + parentName + '"]');
        parent.prop('checked', true);
    }
    });
});

$(document).on('click', '.js-category-pagination .pagination a', function (e) {
    e.preventDefault();

    if ($(this).data('page')) {
        filters.page = $(this).data('page');
    }
    getCategoryResults(filters);

});

$('.js-category-page').on('click', '.js-all-filters.js-sort-radio', function() {
    $(this).parents('.js-options').siblings('.js-sort-btn').removeClass('is-open');
});

$('.js-category-page').on('change', '.js-all-filters', function() {
    var $this = $(this);

    if ($this.data('field')) {
        filters.field = $this.data('field');
    }

    if ($this.data('dir')) {
        filters.dir = $this.data('dir');
    }

    if ($this.data('price')) {
        filters.price = (filters.price == $this.data('price')) ? '' : $this.data('price');
        filters.page = 1;
    }

    if ($this.data('subcategory')) {
        filters.page = 1;
        let searchSubcategory = subcategories.indexOf($this.data('subcategory').toString());

        if (searchSubcategory != -1) {
            subcategories.splice(searchSubcategory, 1);
        } else {
            subcategories.push($this.data('subcategory').toString());
        }
    }

    if ($this.data('neighborhood')
        && $this.data('neighborhood') != 'parent') {
            filters.page = 1;
            let searchNeighborhood = neighborhoods.indexOf($this.data('neighborhood').toString());

            if (searchNeighborhood != -1) {
                neighborhoods.splice(searchNeighborhood, 1);
            } else {
                neighborhoods.push($this.data('neighborhood').toString());
        }
    }

    if ($this.data('neighborhood') == 'parent') {
        let neibChild = $('.js-neighborhood-child');
        $.each(neibChild, (key, item) => {
            if ($(item).data('neighborhood-parent') == $.trim($this.data('neighborhood-parent-name'))) {
                if (this.checked) {
                    neighborhoods.push($(item).data('neighborhood').toString());
                } else {
                    neighborhoods = $.grep(neighborhoods, function(value){
                        return value != $(item).data('neighborhood');
                    });
                }
            }
        });
    }

    if ($this.data('addinfo')
        && $this.data('addinfo') != 'parent') {
            filters.page = 1;
            let searchAddInfo = addinfos.indexOf($this.data('addinfo').toString());

            if (searchAddInfo != -1) {
                addinfos.splice(searchAddInfo, 1);
            } else {
                addinfos.push($this.data('addinfo').toString());
        }

    }

   if ($this.data('addinfo') == 'parent') {
        let addInfoChild = $('.js-addinfo-child');
        $.each(addInfoChild, (key, item) => {
            if ($(item).data('addinfo-parent') == $.trim($this.data('addinfo-parent-name'))) {
                if (this.checked) {
                    addinfos.push($(item).data('addinfo').toString());
                } else {
                    addinfos = $.grep(addinfos, function(value){
                        return value != $(item).data('addinfo');
                    });
                }
            }
        });
    }

    if ($this.data('tips')) {
        filters.page = 1;
        filters.tips = $this.prop('checked') ? $this.data('tips') : '';
    }

    if ($this.data('rated')) {
        filters.page = 1;
        filters.rated = $this.prop('checked') ? $this.data('rated') : '';
    }

    filters.subcategories = subcategories.join(',');
    filters.neighborhoods = neighborhoods.join(',');
    filters.addinfos = addinfos.join(',');

    highlightActiveFilters(filters);
    getCategoryResults(filters);
});

$('.js-category-page').on('click', '.js-dates-filter-btn', function() {

    var datesFilterStart = $('.js-dates-filter-start');
    var fpStart = datesFilterStart.closest('.flatpickr-filters-start')[0]._flatpickr;

    var datesFilterEnd = $('.js-dates-filter-end');
    var fpEnd = datesFilterEnd.closest('.flatpickr-filters-end')[0]._flatpickr;

    var startDate = fpStart.selectedDates.length > 0 ? fpStart.selectedDates[0].toLocaleDateString("en-US") : "";
    var endDate = fpEnd.selectedDates.length > 0 ? fpEnd.selectedDates[0].toLocaleDateString("en-US") : "";

    filters.startDate = startDate;
    filters.endDate = endDate;
    filters.page = 1;

    var isValid = updateDatesValidationMessage();

    if (!isValid) {
        return;
    }

    highlightActiveFilters(filters);
    getCategoryResults(filters);
});

$('.js-category-page').on('click', '.js-dates-filter-clear-btn', function() {

    var datesFilterStart = $('.js-dates-filter-start');
    var fpStart = datesFilterStart.closest('.flatpickr-filters-start')[0]._flatpickr;
    fpStart.clear();

    var datesFilterEnd = $('.js-dates-filter-end');
    var fpEnd = datesFilterEnd.closest('.flatpickr-filters-end')[0]._flatpickr;  
    fpEnd.clear(); 

    updateDatesValidationMessage();

    filters.startDate = '';
    filters.endDate = '';
    filters.page = 1;

    highlightActiveFilters(filters);
    getCategoryResults(filters);
});

$('.js-search-reset').on('click', function() {
    filters = {};

    highlightActiveFilters(filters);
    getCategoryResults(filters);
});

let streamCount = 0;

function getCategoryResults(filters) {
    progressBar.configure({ parent: '.js-category-content-results' });

    let recursiveEncoded = $.param(filters);
    let newString = location.pathname + '?' + recursiveEncoded;

    history.pushState(filters, '', newString);

    throttle.start(() => (
            $.ajax({
                url: window.location.href,
                type: 'GET',
                data: filters,
                beforeSend: function(xhr) {
                    ++streamCount;
                    progressBar.start();
                    initMap.emptyMap();
                    $('.js-sort-btn').prop('disabled', true);
                },
                success: function(data) {
                    --streamCount;
                    if (streamCount > 0) return;

                    $('.js-category-content__container-result').html(data);
                    $('.js-sort-btn').prop('disabled', false).removeClass('is-open');

                    setTimeout(function() {
                        var $img = $('.category-content__list.js-search-content .category-content__img img');
                        $img.on('load', globalFunctions.resizeProductResultsImagesDebounced);
                    }, 1);
                },
                error: function(req, text, error) {
                    --streamCount;
                    if (streamCount > 0) return;

                    let errors = [];
                    let response = {};
                    try {
                        response = req.responseJSON;
                        for (let prop in response.errors) {
                            errors.push(response.errors[prop]);
                        }
                    } catch (e) {}
                },
                complete: function() {
                    initMap.emptyMap();
                    initMap.setMarkers();

                    if (streamCount < 1) progressBar.done();
                }
            })
        ),
        1000
    );
}

function highlightActiveFilters(filters) {
    $.each($('.js-sort-paragraph'), function(index, value) {
        let hiddenRadio = $(this).next();
        if (hiddenRadio.data('dir') == filters.dir && hiddenRadio.data('field') == filters.field) {
            $(this).addClass('is-checked');
        } else {
            $(this).removeClass('is-checked');
        }
    });
}

function isValidDateSelection() {
    var datesFilterStart = $('.js-dates-filter-start');
    var fpStart = datesFilterStart.closest('.flatpickr-filters-start')[0]._flatpickr;

    var datesFilterEnd = $('.js-dates-filter-end');
    var fpEnd = datesFilterEnd.closest('.flatpickr-filters-end')[0]._flatpickr;

    var startDate = fpStart.selectedDates.length > 0 ? fpStart.selectedDates[0] : undefined;
    var endDate = fpEnd.selectedDates.length > 0 ? fpEnd.selectedDates[0] : undefined;

    // If only one date is selected, the selection is valid
    if (startDate == undefined || endDate == undefined) {
        return true;
    }
       
    // If both dates are selected, ensure the end date is greater than the start date
    if (startDate > endDate) {
        return false;
    }
    else {
        return true;
    }
}

function updateDatesValidationMessage() {
    var isValid = isValidDateSelection();

    if (isValid) {
        $('.dates-filter-error-message').text('');
    }
    else {
        $('.dates-filter-error-message').text('Please enter a valid date range.');
    }

    return isValid;
}

$(function() {
    applyFlatPickrToInput('.flatpickr-filters-start', 'startDate');
    applyFlatPickrToInput('.flatpickr-filters-end', 'endDate');
    updateDatesValidationMessage();

    function applyFlatPickrToInput(elementIdentifier, queryParamName) {
        var flatpickrOptions = {
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'Y-m-d',
            minDate: 'today',
            disableMobile: false,
            wrap: true,
            onChange: flatpickrFilterOnChange
        };

        var element = $(elementIdentifier);

        var defaultDate = element.data('defaultvalue');

        if (defaultDate == undefined || defaultDate == '') {
            const urlParams = new URLSearchParams(window.location.search);
            const dateParam = urlParams.get(queryParamName);
            
            if (dateParam != undefined && dateParam != '') {
                defaultDate = new Date(dateParam);
            }
        }

        if (defaultDate != undefined && defaultDate != '') {
            flatpickrOptions.defaultDate = defaultDate;
            element.addClass("has-value");
        }  

        element.flatpickr(flatpickrOptions);
    }    

    function flatpickrFilterOnChange(selectedDates, dateStr, instance) {
        var isValid = isValidDateSelection();

        if (isValid) {
            $('.dates-filter-error-message').text('');
        }
        else {
            $('.dates-filter-error-message').text('Please enter a valid date range.');
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/category/results-filter.js